import { Create } from "react-admin";
import SaveForm from "./SaveForm";
import BackButtonToolbar from "features/BackButtonToolbar";

const CreateEmployees = () => {
  return (
    <Create
      title="Създаване на служител"
      actions={<BackButtonToolbar />}
    >
      <SaveForm create={true} />
    </Create>
  );
};
export default CreateEmployees;
